/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var PersonIngestionStageRequest;
(function (PersonIngestionStageRequest) {
    let fileHost;
    (function (fileHost) {
        fileHost["GCS"] = "GCS";
        fileHost["LOCAL"] = "LOCAL";
    })(fileHost = PersonIngestionStageRequest.fileHost || (PersonIngestionStageRequest.fileHost = {}));
})(PersonIngestionStageRequest || (PersonIngestionStageRequest = {}));
